var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup407(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H50V50H0z",
    transform: "translate(-46 -188) translate(46 188)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.189 45.581a2.859 2.859 0 0 1-2.454-1.422l-3.811-6.48-3.8 6.48a2.868 2.868 0 0 1-2.459 1.428 2.662 2.662 0 0 1-.788-.115l-8.124-2.383v10.82a1.93 1.93 0 0 0 1.434 1.884L18 59.081a3.759 3.759 0 0 0 1.837 0l12.825-3.288a1.941 1.941 0 0 0 1.438-1.885V43.089l-8.119 2.377a2.662 2.662 0 0 1-.792.115zm12.6-6.82l-3.052-6.249a.963.963 0 0 0-.99-.541L18.924 33.91l5.434 9.245a.963.963 0 0 0 1.1.444l11.728-3.434a1.008 1.008 0 0 0 .602-1.404zM3.113 32.512L.061 38.761a1 1 0 0 0 .6 1.4l11.728 3.434a.963.963 0 0 0 1.1-.444l5.44-9.239L4.1 31.971a.963.963 0 0 0-.984.541z",
    transform: "translate(-46 -188) translate(52.939 168.106)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup407);
export default __webpack_public_path__ + "static/media/Group 407.8081b4aac06c48f074c3bb1b6febf855.svg";
export { ForwardRef as ReactComponent };